export const LOADING_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  LOADED: 'loaded',
  NOT_LOADED: 'not-loaded',
};
